export const SET_QUERY_RESULTS = 'SetQueryResults';
export const SET_BULK_EDIT_INFO = 'SetBulkEditInfo';
export const SET_BULK_EDIT_RUN_RESULTS = 'SetBulkEditRunResults';
export const SET_PARTS_ORDERS = 'SetPartsOrders';
export const SET_BULK_IMPORT_RESULTS = 'SetBulkImportResults';
export const SET_PARTS_VENDORS = 'SetPartsVendors';
export const UPDATE_SELECTED_QUERY_RESULTS = 'UpdateSelectedQueryResults';
export const UPDATE_SELECT_ALL_QUERY_RESULTS = 'UpdateSelectAllQueryResults';
export const REMOVE_PARTS_ORDERS = 'RemovePartsOrders';
